/*! Copyright (c) 2025, XAPP AI */

/**
 * From a given zip code, determine if it is in the service area defined by the provided zip codes.
 *
 * @param zip Zip code as a string
 * @param zipCodes Array of zip codes that define the service area, masking is supported, such as "12345", "1234*", "123*5", "12*45".
 */
export function isInServiceArea(zip: string, zipCodes: string[]): boolean {
    // Normalize input ZIP: keep only 5 digits
    const baseZip = zip.slice(0, 5);

    const foundSupportedZip = zipCodes.find((supportedZip) => {
        // If the supported zip code is an exact match, return true
        if (supportedZip === baseZip) {
            return true;
        }

        // If the supported zip code contains asterisks, we need to check for a match
        if (supportedZip.includes("*")) {
            // Replace asterisks with regex wildcard and create a regex pattern
            const regexPattern = supportedZip.replace(/\*/g, "\\d") + "$";
            const regex = new RegExp(`^${regexPattern}`);
            return regex.test(baseZip);
        }

        // If no match found, return false
        return false;
    });

    // If we found a supported zip code, return true, otherwise false
    return !!foundSupportedZip;
}
